import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import LookListLeft from "./lookListLeft";
import LookListContent from "./lookListContent";
import {setLookOverlayOpened, setLookPageOpened, setLookStylePopup} from "../../../actions/lookFunctions";
import {ROUTES} from "../../../routes";
import {LOOK_OVERLAYS} from "../core/constants";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import LookListFooter from "./lookListFooter";
// import {updateSureTax} from "../../../misc/updateSureTax";

const LookList = (props) => {

  const {setLookPageOpened, history, hideOverlay, lookRemovedCartItems, setLookOverlayOpened, setLookStylePopup,
    isMobile} = props;

  // useEffect(() => {
  //   if (shouldUpdateSureTax) {
  //     updateSureTax()
  //   }
  // }, [shouldUpdateSureTax])

  const popupCloseClick = () => {

    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListBackToCustomize);

    if (lookRemovedCartItems.length) {
      setLookOverlayOpened(LOOK_OVERLAYS.styleRemoveBack);
      setLookStylePopup({
        notMatchingFeatures: [...lookRemovedCartItems
          .filter(cartItem => cartItem.cartFeature && !cartItem.relatedProductParent)
          .map(cartItem => cartItem.cartFeature)
        ]
      });
      return false
    }

    setLookPageOpened("");
    hideOverlay(() => {
      history.push(ROUTES.home)  // fade out && router change after
    });
  }

  return (
    <div className="ll">
      <div className="ll-body ll-body--list">
        <LookListLeft onBackClick={popupCloseClick}/>
        <LookListContent onBackClick={popupCloseClick}/>
      </div>
      {isMobile ? null : <LookListFooter/>}
    </div>
  )
};

const mapStateToProps = (store) => {
  // const {lookRemovedCartItems, cartItems} = store.cartState;
  // const {isMobile, visualizersLoaded} = store.serverState;
  const {lookRemovedCartItems} = store.cartState;
  const {isMobile} = store.cartState;

  return {
    lookRemovedCartItems,
    isMobile,
    // shouldUpdateSureTax: visualizersLoaded.length && cartItems.length
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOverlayOpened,
  setLookStylePopup,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookList)
)
